export { default } from './PartGroupAccordion';
